import { useNavigate } from "react-router-dom";
import { getUserInfo, loginApi,deleteAccount } from "./auth/Api";
import { useEffect, useState } from "react";
import { useAuth } from "./auth/Authcontext";
import { toast } from 'react-toastify';
import "./delete-account.css";

export default function DeleteAccount() {

  const [username ,setUsername] = useState("")
  const [password , setPassword] = useState("")
  const [errorMessage , setErrorMessage] = useState(null)
  const navigate = useNavigate();
  const { login , contextValue,updateUserData , authToken} = useAuth();
  const [btnDisabled , setBtnDisabled] = useState(false)


  useEffect(() => {


    if(authToken){

      navigate("/home");

    }
    

  },[authToken])

  const getuserinfo = () => {
      getUserInfo().then((response) => {


        updateUserData(response.data)

        console.log(response.data)

      })
      .catch(error => console.error(error))
      .finally(() => {});
  }

    const handleSubmit = async (event) => { 

      if(!username && !password){
        toast.error("Username or Password required");

        return;
      }

      setBtnDisabled(true)
      event.preventDefault();

      try{

        contextValue.showLoader();
        contextValue.updateLoaderText("Fetching user details...");

        const response = await loginApi(
          {
            "username": username,
            "password": password ,
            "userType": "User"
          }
        )

        setBtnDisabled(false)
        contextValue.hideLoader()

        if(response.status == 200){
            contextValue.showLoader();
            contextValue.updateLoaderText("Deleting account...");
            try{
                await deleteAccount(response.data.access_token)

                toast.success("Account deleted successfully");
               
            }
            catch(error){
              console.log(error)
            }finally{
              contextValue.hideLoader()
            }
            
          console.log(response.data.access_token)
        //   getuserinfo(response.data.access_token)
          

         // console.log("logned in",response.data.access_token)
        //   login(response.data);
        //   navigate("/home");
        }

        else {

          toast.error(response.data.message || "Login failed");

          setErrorMessage(response.data.message || "Login failed")
          
          //alert()
        }

       // console.log(response)


      }catch(error){

        console.log(error)
        setBtnDisabled(false)
        contextValue.hideLoader()

        if(error.response.data.message){
          setErrorMessage(error.response.data.message || "Login failed")
          toast.error(error.response.data.message  || "Login failed")
        }else{
          setErrorMessage("Login failed")
          toast.error("Login failed")
        }




        console.log(error)
      }



    }
    return (

      <div className=" ">
      <div className="delete-account ">
        <h1>Delete Your FanStable Account</h1>

        <form onSubmit={handleSubmit} method="POST">
            <label for="email">Email Address</label>
            <input type="email" id="email" name="email" placeholder="your@email.com" required 
            defaultValue={username}
            
            onChange={(e) => setUsername(e.target.value)}
            />

            <label for="password">Password</label>
            <input type="password" id="password" name="password" placeholder="Your account password" required 
            defaultValue={password}
            onChange={(e) => setPassword(e.target.value)}
            />

            <button type="submit">Delete Account</button>
        </form>

        <div class="info">
            <h2>Important Information</h2>
            <p>FanStable collects information such as your email, profile details, uploaded images, and usage data to provide core functionality, analytics, and push notifications.</p>
            <p>You can delete your account and all associated data using the form above. Your request will be processed within immediately.</p>
            <p>All third-party SDKs used (Appsflyer, OneSignal, Facebook SDK) handle data according to their privacy policies. For more information, please visit our <a href="http://playfanstable.com/privacypolicy" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
      </div>
    );
  }